import React from "react";
import { SPORTS } from "../mock";

const Spotlight = () => {
  return (
    <section id="spotlight" className="py-16 sm:py-24 bg-[var(--cream-2)]/50 border-t border-[var(--line)]">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="flex items-center gap-4 mb-5">
          <span className="h-[2px] w-10 bg-[var(--olive)]" />
          <span className="text-xs font-bold tracking-eyebrow text-[var(--muted)] uppercase">
            Six sports · Boys &amp; girls
          </span>
        </div>
        <h2 className="text-4xl sm:text-6xl font-extrabold tracking-tight text-[var(--ink)] max-w-3xl mb-12">
          Sports we{" "}
          <span className="font-serif-display italic font-medium text-[var(--olive-2)]">
            rank
          </span>
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {SPORTS.map((s) => (
            <a
              key={s.id}
              href="#rankings"
              className="group relative h-40 rounded-2xl overflow-hidden"
            >
              <img
                src={s.image}
                alt={s.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/85 via-[var(--ink)]/20 to-transparent" />
              <div className="absolute bottom-4 left-4">
                <span className="block text-lg font-extrabold text-[var(--cream)]">
                  {s.label}
                </span>
                <span className="text-[12px] font-semibold text-[var(--olive)]">
                  {s.season} season
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Spotlight;
